import { Navigate } from 'react-router-dom';

/**
 * Detects user language preference and redirects to /ko or /en.
 * Preserves existing query string and hash fragment.
 *
 * Detection order:
 * 1. localStorage (i18next key)
 * 2. navigator.language (Accept-Language equivalent on the client)
 * 3. Fallback to 'ko'
 */
function detectLanguage(): 'ko' | 'en' {
  // Check localStorage (set by i18next LanguageDetector)
  const stored = localStorage.getItem('i18nextLng');
  if (stored === 'ko' || stored === 'en') {
    return stored;
  }
  // Partial match (e.g. 'ko-KR', 'en-US')
  if (stored?.startsWith('en')) return 'en';
  if (stored?.startsWith('ko')) return 'ko';

  // navigator.language
  const nav = navigator.language ?? '';
  if (nav.startsWith('en')) return 'en';
  if (nav.startsWith('ko')) return 'ko';

  return 'ko';
}

export function RootRedirect() {
  const lang = detectLanguage();
  // Preserve query string and hash
  const search = window.location.search;
  const hash = window.location.hash;
  return <Navigate to={`/${lang}${search}${hash}`} replace />;
}
